import '@hems/component/resources/scss/main.scss';
import { defineComponent, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import SmartModuleMobileHomeContainerDemo from '@hems/container/src/forms/device/smartmodule/home/SmartModuleMobileHomeContainerDemo.vue';
import { MobileHelper } from '@hems/util';
export default defineComponent({
    name: 'SmartModuleMobileHomeDemo',
    components: {
        SmartModuleMobileHomeContainerDemo,
    },
    setup() {
        const store = useStore();
        // Add Listener
        MobileHelper.addEventListener('loadAppCtx', (appCtx) => {
            store.dispatch('appCtx/setTheme', appCtx.theme);
            store.dispatch('appCtx/setLangCd', appCtx.theme);
        });
        function loadAppCtx() {
            MobileHelper.webToApp({
                action: 'mapper_load_appCtx',
                callback: 'loadAppCtx',
            });
        }
        onMounted(() => {
            loadAppCtx();
        });
        onUnmounted(() => {
            MobileHelper.removeEventListener('loadAppCtx');
        });
        return {
            store,
        };
    },
});
